(function () {
  'use strict';

  function init(root) {
    var germanCopy = {"Let’s talk about working together.": "Lass uns über eine Zusammenarbeit sprechen.", "Tell us about your studio or business, or ask for artwork information. No current project is needed.": "Erzähl uns von deinem Studio oder Unternehmen oder frage nach Informationen zu einem Werk. Du brauchst noch kein konkretes Projekt.", "Tell us about your business or the artwork information you need.": "Erzähl uns von deinem Unternehmen oder welche Informationen zu einem Werk du suchst.", "Add business details (optional)": "Unternehmensdetails ergänzen (optional)", "Please enter your name.": "Bitte gib deinen Namen ein.", "Please enter your company, studio or name.": "Bitte gib dein Unternehmen, dein Studio oder deinen Namen ein.", "Please add a short message.": "Bitte ergänze eine kurze Nachricht.", "Sending…": "Wird gesendet …", "Tell us about your project.": "Erzähl uns von deinem Projekt.", "Share a few details or ask about a work. We’ll get back to you with the next step.": "Beschreibe kurz dein Vorhaben oder stell uns eine Frage zu einem Werk. Wir melden uns mit dem nächsten Schritt.", "A few details, a question, or the works you’re considering.": "Ein paar Angaben, eine Frage oder die Werke, die dich interessieren.", "Add project details (optional)": "Projektdetails ergänzen (optional)", "Please enter a valid email address.": "Bitte gib eine gültige E-Mail-Adresse ein."};
    function tr(text) { return root.lang === "de" ? (germanCopy[text] || text) : text; }
    var body = document.body;
    var drawer = root.querySelector('[data-b2b-drawer]');
    var backdrop = root.querySelector('[data-b2b-drawer-backdrop]');
    var openButton = root.querySelector('[data-b2b-menu-open]');
    var closeButton = root.querySelector('[data-b2b-menu-close]');
    var returnFocus = null;

    function drawerFocusable() {
      return Array.prototype.slice.call(drawer.querySelectorAll('a[href], button:not([disabled])'));
    }
    function openDrawer() {
      returnFocus = document.activeElement;
      backdrop.hidden = false;
      drawer.hidden = false;
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      body.classList.add('artmere-b2b-drawer-open');
      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        closeButton.focus();
      });
    }
    function closeDrawer(restoreFocus) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      body.classList.remove('artmere-b2b-drawer-open');
      backdrop.hidden = true;
      if (restoreFocus !== false && returnFocus && openButton.offsetParent !== null) returnFocus.focus();
    }
    openButton.addEventListener('click', openDrawer);
    closeButton.addEventListener('click', function () { closeDrawer(true); });
    backdrop.addEventListener('click', function () { closeDrawer(true); });
    drawer.querySelectorAll('[data-b2b-drawer-link]').forEach(function (link) {
      link.addEventListener('click', function () { closeDrawer(true); });
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 760 && drawer.classList.contains('is-open')) closeDrawer(false);
    });
    document.addEventListener('keydown', function (event) {
      if (!drawer.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer(true);
        return;
      }
      if (event.key !== 'Tab') return;
      var items = drawerFocusable();
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    var form = root.querySelector('#ArtmereB2BContact');
    var success = root.querySelector('[data-b2b-success]');
    if (success) success.focus({ preventScroll: true });
    if (!form) return;

    var title = root.querySelector('[data-b2b-enquiry-title]');
    var intro = root.querySelector('[data-b2b-enquiry-body]');
    var message = root.querySelector('[data-b2b-message]');
    var optionalLabel = root.querySelector('[data-b2b-optional-label]');
    var enquiryType = root.querySelector('[data-b2b-enquiry-type]');
    var projectFields = root.querySelector('[data-b2b-project-fields]');
    var tradeFields = root.querySelector('[data-b2b-trade-fields]');

    function setGroupState(group, active) {
      group.hidden = !active;
      group.querySelectorAll('input, select, textarea').forEach(function (field) { field.disabled = !active; });
    }
    root.querySelectorAll('input[name="artmere-b2b-enquiry-mode"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        var trade = radio.value === 'Trade partnership';
        enquiryType.value = radio.value;
        title.textContent = trade ? tr("Let’s talk about working together.") : tr("Tell us about your project.");
        intro.textContent = trade ? tr("Tell us about your studio or business, or ask for artwork information. No current project is needed.") : tr("Share a few details or ask about a work. We’ll get back to you with the next step.");
        message.placeholder = trade ? tr("Tell us about your business or the artwork information you need.") : tr("A few details, a question, or the works you’re considering.");
        optionalLabel.textContent = trade ? tr("Add business details (optional)") : tr("Add project details (optional)");
        setGroupState(projectFields, !trade);
        setGroupState(tradeFields, trade);
      });
    });

    var optionalToggle = root.querySelector('[data-b2b-optional-toggle]');
    var optional = document.getElementById('ArtmereB2BOptional');
    optionalToggle.addEventListener('click', function () {
      var expanded = optionalToggle.getAttribute('aria-expanded') === 'true';
      optionalToggle.setAttribute('aria-expanded', String(!expanded));
      optional.hidden = expanded;
    });

    var validationSummary = root.querySelector('[data-b2b-validation-summary]');
    var checks = [
      { id: 'ArtmereB2BName', key: 'name', message: tr("Please enter your name.") },
      { id: 'ArtmereB2BEmail', key: 'email', message: tr("Please enter a valid email address.") },
      { id: 'ArtmereB2BCompany', key: 'company', message: tr("Please enter your company, studio or name.") },
      { id: 'ArtmereB2BMessage', key: 'message', message: tr("Please add a short message.") }
    ];
    function emailIsValid(value) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value); }
    function validate() {
      var firstInvalid = null;
      checks.forEach(function (check) {
        var field = document.getElementById(check.id);
        var invalid = check.key === 'email' ? !emailIsValid(field.value.trim()) : !field.value.trim();
        var wrapper = field.closest('.artmere-b2b__field');
        var output = wrapper.querySelector('[data-b2b-error-for="' + check.key + '"]');
        wrapper.classList.toggle('is-invalid', invalid);
        field.setAttribute('aria-invalid', String(invalid));
        output.textContent = invalid ? check.message : '';
        if (invalid && !firstInvalid) firstInvalid = field;
      });
      validationSummary.hidden = !firstInvalid;
      return firstInvalid;
    }
    var submitting = false;
    form.addEventListener('submit', function (event) {
      if (root.querySelector('[data-b2b-honeypot]').value) {
        event.preventDefault();
        return;
      }
      var firstInvalid = validate();
      if (firstInvalid) {
        event.preventDefault();
        validationSummary.focus();
        return;
      }
      if (submitting) {
        event.preventDefault();
        return;
      }
      submitting = true;
      var submit = root.querySelector('[data-b2b-submit]');
      submit.disabled = true;
      submit.setAttribute('aria-disabled', 'true');
      submit.textContent = tr("Sending…");
    });
  }

  document.querySelectorAll('[data-artmere-b2b]').forEach(init);
}());
